import React from "react";
import Loadable from "../../react-loadable";

const WeaTreeEdit = Loadable({
  loader: () => import("./TreeEdit"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaTreeEdit;



// WEBPACK FOOTER //
// ./ecology9/wea-tree-edit/index.js